<section class="page">
  <header class="page-header">
    <h2>Groupes d'amorces</h2>
    <p class="subtitle">Créer, modifier et voir/supprimer les groupes d'amorces.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (showCreateSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="createGroupe()">
        <h3>Créer un groupe d'amorces</h3>

        <label for="nouveau-nom">Nom</label>
        <input id="nouveau-nom" name="nouveauNom" [(ngModel)]="nouveauNom" maxlength="255" required />

        <fieldset>
          <legend>Amorces du groupe</legend>
          @if (loadingAmorces) {
            <p>Chargement des amorces...</p>
          } @else if (amorces.length === 0) {
            <p>Aucune amorce disponible.</p>
          } @else {
            <div class="checkbox-list">
              @for (amorce of amorces; track amorce.id) {
                <label class="checkbox-item">
                  <input
                    type="checkbox"
                    [checked]="isCreateAmorceChecked(amorce.id)"
                    (change)="toggleCreateAmorce(amorce.id, $any($event.target).checked)"
                  />
                  <span>{{ getAmorceLabel(amorce) }}</span>
                </label>
              }
            </div>
          }
        </fieldset>

        <button type="submit" [disabled]="loading">Créer</button>
      </form>
    </div>
  }

  @if (showEditSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="updateGroupe()">
        <h3>Éditer un groupe d'amorces</h3>

        <label for="select-groupe">Groupe</label>
        <select id="select-groupe" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
          <option value="">-- sélectionner --</option>
          @for (groupe of groupes; track groupe.id) {
            <option [value]="groupe.id">{{ groupe.nom }}</option>
          }
        </select>

        <label for="nom-edition">Nom</label>
        <input id="nom-edition" name="nomEdition" [(ngModel)]="nomEdition" maxlength="255" required />

        <fieldset>
          <legend>Amorces du groupe</legend>
          @if (loadingAmorces) {
            <p>Chargement des amorces...</p>
          } @else if (amorces.length === 0) {
            <p>Aucune amorce disponible.</p>
          } @else {
            <div class="checkbox-list">
              @for (amorce of amorces; track amorce.id) {
                <label class="checkbox-item">
                  <input
                    type="checkbox"
                    [checked]="isEditAmorceChecked(amorce.id)"
                    (change)="toggleEditAmorce(amorce.id, $any($event.target).checked)"
                  />
                  <span>{{ getAmorceLabel(amorce) }}</span>
                </label>
              }
            </div>
          }
        </fieldset>

        <button type="submit" [disabled]="loading">Enregistrer</button>
      </form>
    </div>
  }

  @if (showListSection) {
    <section class="panel">
      <h3>Liste des groupes d'amorces</h3>
      @if (loadingList) {
        <p>Chargement des groupes d'amorces...</p>
      } @else if (groupes.length === 0) {
        <p>Aucun groupe d'amorces disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nom</th>
                <th>Amorces</th>
                @if (showDeleteActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (groupe of groupes; track groupe.id) {
                <tr>
                  <td>{{ groupe.id }}</td>
                  <td>{{ groupe.nom }}</td>
                  <td>{{ groupe.amorces_codes || groupe.amorces_noms || '-' }}</td>
                  @if (showDeleteActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingId === groupe.id"
                        (click)="deleteGroupeRow(groupe)"
                      >
                        {{ deletingId === groupe.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }
</section>
